/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotomanual3Inputs */

const en_aiflowphotomanual3 = /** @type {(inputs: Aiflowphotomanual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design it myself`)
};

const de_aiflowphotomanual3 = /** @type {(inputs: Aiflowphotomanual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbst gestalten`)
};

/**
* | output |
* | --- |
* | "Design it myself" |
*
* @param {Aiflowphotomanual3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotomanual3 = /** @type {((inputs?: Aiflowphotomanual3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotomanual3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotomanual3(inputs)
	return de_aiflowphotomanual3(inputs)
});
export { aiflowphotomanual3 as "aiFlowPhotoManual" }